// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inconsolata:wght@300&display=swap);"]);
// Module
exports.push([module.id, "html,\nbody,\n#root {\n  height: 100%;\n}\n::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\nbody {\n  font-family: 'Inconsolata', monospace;\n  font-weight: 300;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n*::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n* {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n", ""]);
// Exports
module.exports = exports;
